<template>
	<div style="min-width: 1500px; width: 100%;">
		<div class="top-main">
			<div class="title">
				{{ lang === 'zh' ? '开放时间: 9:00—17:00 （16:00停止发票入馆，周一闭馆）' : 'Opening hours: 9:00-17:00 (stop at 16:00 and close on Monday)' }}
				<div class="top-right">
					<div class="search-icon" style="cursor: pointer;" @click="toSearch">
						<i class="iconfont iconsousuo"></i>
					</div>
					<div class="top-right-middel">
						<i class="iconfont icontubiaozhizuo-"></i>
						<Dropdown trigger="click" @on-click="changeLang">
							<a href="javascript:void(0)" style="color: #F4DD8F;">
								<span v-for="(item, index) in langList" :key="index" v-if="item.key == lang">{{item.name}}</span>
								<i class="iconfont iconcaret-down" style="cursor: pointer;"></i>
							</a>
							<DropdownMenu slot="list">
								<DropdownItem v-for="(item, index) in langList" :key="index" v-if="item.key != lang" :name="item.key">
									{{item.name}}
								</DropdownItem>
							</DropdownMenu>
							
						</Dropdown>
						<!-- 中文 -->
						<i class="iconfont icontubiaozhizuo-"></i>
					</div>
					<div class="top-right-right" style="cursor: pointer;" @click="toUserCenter">
						<i class="iconfont iconyonghu"></i>
						<span style="font-size: 9px;cursor: pointer; margin-left: 5px;">
							{{ lang === 'zh' ? '会员中心' : 'Membership Center' }}
						</span>
					</div>
				</div>
			</div>

			<div class="navcontainer">
				<div class="logo">
					<img class="logo-img" :src="lang == 'zh' ? require('/static/logo.png') : require('/static/en_logo.png')" alt="">
				</div>
				<div class="right">
					<div class="title-block">
						
						<div
							:class="'title-box-' + index"
							class="title-box"
							v-for="(item, index) in titleList"
							:key="index"
							:style="{width: lang == 'zh' ? '100px' : '160px',color: chooseIndex === index ? '#FFFFFF' : '#FFFFFF', backgroundImage: chooseIndex === index || showIndex === index ? 'url(../../static/select_top_bar.png)' : ''}"
							@click="selectParentIndex(index)"
							@mouseover="moveIn(index)"
							>
							{{item.name}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="second-title-block" v-if="showSecondTitle" :style="{left: secondBoxLeft, width: lang == 'zh' ? '100px' : '160px'}" @mouseleave="moveOut">

			<div
				v-for="(item, index) in showTitleList"
				:key="index"
				class="second-title-box"
				:style="{width: lang == 'zh' ? '100px' : '160px', color: (secondIndex === index && showIndex === chooseIndex) || showSecondIndex === index ? '#EDD68E' : '#FFFFFF'}"
				@click="selectSecondIndex(index)"
				@mouseover="moveSecondIn(index)"
				@mouseleave="moveSecondOur"
				>
				{{item.name}}
			</div>
		</div>


	</div>
</template>

<script>
	export default {
		name: 'navtop',
		inject: ['reload'],
		data () {
			return {
				showSecondTitle: false,
				secondBoxLeft: "100px",
				showIndex: "",
				secondIndex:0,
				showSecondIndex: "",
				showTitleList: [],
				default_title_list_start: [
					{
						name: "首页",
						children: [],
						path: "/home"
					}
				],
				en_default_title_list_start: [
					{
						name: "Home",
						children: [],
						path: "/en_home"
					}
				],
				defalut_title_list_end: [
					// {
					// 	name: "参观留言",
					// 	children: [],
					// 	path: "/jslt"
					// }
				],
				langList: [
					{
						key: 'zh',
						name: '中文'
					},
					{
						key: 'young',
						name: '青少年版'
					},
					{
						key: 'en',
						name: 'ENGLISH'
					}
				]
			}
		},
		computed: {
			chooseIndex() {
				return this.$store.state.firstSelect
			},
			secondIndex() {
				return this.$store.state.secondSelect
			},
			titleList() {
				return this.$store.state.titleList
			},
			lang() {
				return this.$store.state.lang
			},
			enTitleList() {
				return this.$store.state.enTitleList
			}
		},
		mounted() {
			this.getTree()
		},
		methods: {
			toSearch() {
				this.$router.push('search')
			},
			getTree() {
				this.$http.post({
					url: '/api/channel/findChannelTree/',
					data: {
						siteId: this.lang === 'zh' ? 1 : 3
					}
				}).then(res => {
					var titleList = []
					if(res.code === 'S200') {
						if(this.lang === 'zh') {
							titleList.push(...this.default_title_list_start)
							titleList.push(...res.data)
							titleList.push(...this.defalut_title_list_end)
						} else {
							titleList.push(...this.en_default_title_list_start)
							titleList.push(...res.data)
						}
					}
					this.$store.state.titleList = titleList
				})
			},
			moveIn(index) {
				let that = this
				that.showIndex = index
				that.showSecondIndex = ""
				if(that.titleList[that.showIndex].children && that.titleList[that.showIndex].children.length > 0){
					var chooseDiv = document.getElementsByClassName('title-box-' + index)[0]
					var tmp = chooseDiv.offsetLeft
					var val = chooseDiv.offsetParent;
					while(val != null){
						tmp += val.offsetLeft;
						val = val.offsetParent;
					}
					that.secondBoxLeft = tmp + 'px'
					that.showSecondTitle = true
					that.showTitleList = that.titleList[that.showIndex].children
					
					
				} else {
					that.showSecondTitle = false
					that.showTitleList = []
				}
			},
			changeLang(e) {
				let that = this
				that.$store.state.lang = e
				if(e == 'young') {
					that.$router.push('young_index')
				} else {
					that.getTree()
					if(e == 'zh') {
						that.$router.push('home')
					} else {
						that.$router.push('en_home')
					}

				}
			},
			moveSecondIn(index) {
				let that = this
				that.showSecondIndex = index
			},
			moveSecondOur() {
				let that = this
				that.showSecondIndex = ""
			},
			moveOut() {
				this.showSecondTitle = false
				this.showIndex = ""
				this.howSecondIndex = ""
			},
			routerpush (to) {
				this.$router.push(to)
			},
			selectParentIndex(index) {
				let that = this
				that.showSecondTitle = true
				if(that.titleList[index].children && that.titleList[index].children.length > 0) {
					return
				} else {
					that.$store.state.firstSelect = index
					that.showSecondTitle = false
					that.$store.state.secondList = []
					that.$store.state.secondSelect = ""
					that.$store.state.channelId = that.titleList[index].id
					that.routerpush(that.titleList[that.chooseIndex].path)
				}
		
			},
			selectSecondIndex(index) {
				let that = this
				console.log(index);
				console.log('that.$store',that.$store);
				console.log('that.that.showTitleList',that.showTitleList);
				console.log('secondIndex',that.secondIndex);
				that.$store.state.firstSelect = that.showIndex*1
				that.$store.state.secondSelect = index
				
				this.showSecondIndex=index
				
				that.secondIndex?'':that.secondIndex=0
				that.showSecondTitle = false
				that.$store.state.secondList = that.showTitleList
				console.log('secondIndex',that.secondIndex);
				console.log('secondIndex', that.showTitleList[that.secondIndex]);
				that.$store.state.channelId = that.showTitleList[that.secondIndex].id
				if(that.$store.state.firstSelect == 4 && that.$store.state.secondSelect == 0 && that.$store.state.lang == 'zh') {
					that.$store.state.channelId = that.$store.state.secondList[0].children[0].id
					that.$store.state.chenLieType = "jbcl"
				}
				
				that.routerpush(that.showTitleList[that.secondIndex].path)
			},
			toUserCenter() {
				let that = this
				that.$store.state.firstSelect = ""
				that.$store.state.secondSelect = ""
				that.showSecondTitle = false
				that.$store.state.secondList = {}
				that.$router.push('/grxx')
			}
		}
	}
</script>

<style lang="less" scoped>
	.top-main {
		height: 88px;
		width: 100%;
		min-width: 1500px;
		background: #264EA7;
		.navcontainer {
			top: 0;
			display: flex;
			justify-content: space-between;
			height: 100%;
			.logo {
				height: 100%;
				width: 500px;
				.logo-img {
					width: 450px;
					height: 45px;
					margin: 27px 0 0 40px;
				}
			}
			.right {
				margin-left: calc(1% + 40px);
				width: 90%;
				display: flex;
				justify-content: space-between;
				position: relative;
				margin-top: 53px;
				height: 35px;
				.title-block {
					width: 90%;
					height: 35px;
					margin: 0 5%;
					position: absolute;
					bottom: 0;
					left: 0;
					display: flex;
					align-items: center;
					.title-box {
						// width: 100px;
						height: 35px;
						line-height: 35px;
						font-size: 18px;
						cursor: pointer;
						background-size: 100% 100%;
						margin-left: 10px;
					}
				}
			}
		}
		.title {
			position: absolute;
			top: 0;
			height: 40px;
			line-height: 40px;
			width: 100%;
			min-width: 1500px;
			text-align: center;
			font-size: 9px;
			color: #F4DD8F;
			.top-right {
				position: absolute;
				top: 0;
				right: 0;
				width: 300;
				height: 40px;
				line-height: 40px;
				display: flex;
				justify-content: space-between;
				padding: 0 10px;
				.search-icon {
					color: #F4DD8F;
					width: 30px;
					i {
						font-size: 15px;
					}
				}
				.top-right-middel {
					color: #F4DD8F;
					padding: 0 10px;
					display: flex;
					justify-content: space-between;
					i {
						font-size: 15px;
					}
				}
				.top-right-right {
					color: #F4DD8F;
					padding: 0 10px;
					display: flex;
					justify-content: space-between;
					i {
						font-size: 15px;
					}
				}
			}
		}
	}
	.second-title-block {
		// width: 100px;
		background-color: #1059BF;
		position: absolute;
		z-index: 999;
		.second-title-box {
			// width: 100px;
			height: 60px;
			line-height: 60px;
			font-size: 18px;
			cursor: pointer;
		}
	}
	
	.c-EDD68E{
		color:#edd68e
	}
	
	.c-FFFFFF{color:#fff}
</style>



// WEBPACK FOOTER //
// src/components/NavTop.vue